import { forwardRef } from 'react'
import { Input, type InputProps } from '#src/components/core/input/Input.tsx'

export interface NumberInputProps extends Omit<
  InputProps,
  'value' | 'onChange' | 'type'
> {
  value: number | null
  onChange: (value: number | null) => void
}

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ value, onChange, ...delegated }, ref) => (
    <Input
      ref={ref}
      value={value ?? ''}
      onChange={(e) =>
        onChange(
          Number.isNaN(e.target.valueAsNumber) ? null : e.target.valueAsNumber
        )
      }
      type="number"
      {...delegated}
    />
  )
)

NumberInput.displayName = 'NumberInput'
